import React from "react"
import { graphql } from "gatsby"

import CmsPage from "@utils/cmsPage"
import { pickCollectionNode, resolveProofCollection } from "@utils/cmsCollections"
import { getPrototypePageSlice } from "@utils/prototypeSlices"

const prototypeSlice = getPrototypePageSlice("features")
const featuresExtraStyles = `${prototypeSlice.extraStyles}

.cms-page .recap-sec .btn {
  border-radius: 8px;
}

.cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider {
  height: 16px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider::-webkit-slider-runnable-track {
  height: 2px;
  border: 0;
  border-radius: 0;
  background: var(--line);
}

.cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider::-webkit-slider-thumb {
  margin-top: -6px;
}

.cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider::-moz-range-track {
  height: 2px;
  border: 0;
  border-radius: 0;
  background: var(--line);
}

.cms-page #seFrames .se-frame .se-f-st,
.cms-page .se-frames .se-frame .se-f-st {
  justify-self: end;
  margin-left: auto;
  text-align: right;
  white-space: nowrap;
}

@media (max-width: 960px) {
  .cms-page .hero,
  .cms-page .cat-nav,
  .cms-page .cms-page__feature-head,
  .cms-page .cms-page__feature-list,
  .cms-page .cms-page__feature-card,
  .cms-page .quote-break,
  .cms-page .recap-sec,
  .cms-page .mc-section__head,
  .cms-page .cms-page__section-head {
    text-align: center;
  }

  .cms-page .hero,
  .cms-page .cms-page__feature-head,
  .cms-page .cms-page__feature-list,
  .cms-page .quote-break,
  .cms-page .recap-sec {
    justify-items: center;
  }

  .cms-page .eyebrow,
  .cms-page .cms-page__eyebrow,
  .cms-page .mc-section__eyebrow,
  .cms-page .kick,
  .cms-page .tag {
    display: inline-flex;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .hero h1,
  .cms-page .cms-page__feature-head h2,
  .cms-page .cms-page__feature-list h5,
  .cms-page .cms-page__feature-card h4,
  .cms-page .quote-break h2,
  .cms-page .recap-sec h2,
  .cms-page .mc-section__heading,
  .cms-page .cms-page__section-title {
    text-align: center;
  }

  .cms-page .hero .lede,
  .cms-page .cms-page__feature-head p,
  .cms-page .cms-page__feature-card p,
  .cms-page .quote-break p,
  .cms-page .recap-sec p,
  .cms-page .mc-section__summary,
  .cms-page .cms-page__section-copy {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .cat-nav-inner {
    justify-content: center;
  }

  .cms-page .cat-nav {
    overflow: hidden;
  }

  .cms-page .cat-nav::before,
  .cms-page .cat-nav::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 2;
    width: 72px;
    pointer-events: none;
  }

  .cms-page .cat-nav::before {
    left: 0;
    background: linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0));
  }

  .cms-page .cat-nav::after {
    right: 0;
    background: linear-gradient(-90deg, #fff 10%, rgba(255, 255, 255, 0));
  }

  .cms-page .cat-nav-inner {
    justify-content: flex-start;
    gap: 14px;
    max-width: none;
    padding-left: max(24px, calc(50vw - 92px));
    padding-right: max(24px, calc(50vw - 92px));
    scroll-padding-left: max(24px, calc(50vw - 92px));
    scroll-padding-right: max(24px, calc(50vw - 92px));
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .cms-page .cat-nav-inner::-webkit-scrollbar {
    display: none;
  }

  .cms-page .cat-nav a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 156px;
    padding: 16px 12px;
    scroll-snap-align: center;
    border-bottom-color: transparent;
    opacity: 0.36;
    transform: scale(0.92);
    transition: color 0.2s ease, opacity 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  }

  .cms-page .cat-nav a.active {
    opacity: 1;
    transform: scale(1);
  }

  .cms-page #dvEv,
  .cms-page .dv-chips {
    align-items: stretch;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  .cms-page #dvEv .dv-chip,
  .cms-page .dv-chips .dv-chip {
    box-sizing: border-box;
    justify-content: center;
    min-height: 44px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    width: 100%;
  }

  .cms-page .dv-lang {
    min-height: 44px;
  }

  .cms-page #seFrames,
  .cms-page .se-frames {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    justify-items: stretch;
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .live[data-card="se"] .se-left {
    grid-template-columns: minmax(0, 1fr);
  }

  .cms-page #seFrames .se-frame,
  .cms-page .se-frames .se-frame {
    box-sizing: border-box;
    width: 100%;
    margin: 0;
  }

  .cms-page .live[data-card="se"] .se-row {
    box-sizing: border-box;
    width: 100%;
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] {
    grid-template-columns: 32px minmax(0, 1fr);
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-body > span {
    font-size: 0;
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-body > span::after {
    content: "Force re-auth after idle";
    font-size: 10px;
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider-wrap {
    grid-column: 1 / -1;
    justify-content: center;
    width: 100%;
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider-wrap::before {
    content: "off";
    color: var(--brand-dk);
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 11px;
    font-weight: 700;
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider {
    flex: 0 0 96px;
    width: 96px;
    max-width: 96px;
  }

  .cms-page .live[data-card="se"] .se-row[data-pol="session"] .se-slider-val {
    min-width: 0;
    text-align: left;
  }

  .cms-page .live[data-card="sub"] .live-hd > span:first-child {
    font-size: 0;
  }

  .cms-page .live[data-card="sub"] .live-hd > span:first-child::after {
    content: "Billing timeline";
    font-size: 12px;
  }

  .cms-page .live[data-card="pm"] .live-hd > span:first-child {
    font-size: 0;
  }

  .cms-page .live[data-card="pm"] .live-hd > span:first-child::after {
    content: "Payment methods";
    font-size: 12px;
  }

  .cms-page .live[data-card="rp"] .live-hd > span:first-child {
    font-size: 0;
  }

  .cms-page .live[data-card="rp"] .live-hd > span:first-child::after {
    content: "Financials";
    font-size: 12px;
  }

  .cms-page .live[data-card="sub"] .sub-meta {
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
  }

  .cms-page .live[data-card="sub"] .sub-meta > div {
    width: 100%;
    text-align: center;
  }

  .cms-page .live[data-card="cu"] .cu-foot {
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    text-align: center;
  }

  .cms-page .live[data-card="cu"] .cu-export {
    align-self: center;
  }

  .cms-page .cms-page__feature-item {
    text-align: left;
  }

  .cms-page .recap-sec .cta-row,
  .cms-page .recap-sec .actions,
  .cms-page .mc-section__actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .cms-page .recap-sec .btn,
  .cms-page .mc-section__actions .btn {
    width: 100%;
  }
}
`

const FeaturesPage = ({ data }) => {
  const page = data.allDatoCmsMcV2FeatureCatalogPage.nodes[0] || {}
  const sectionCollection =
    page.sectionCollection ||
    pickCollectionNode(
      data.allDatoCmsMcV2SectionCollection.nodes,
      null,
      "features-sections"
    )
  const featureCollection =
    page.featureCollection ||
    pickCollectionNode(
      data.allDatoCmsMcV2FeatureCollection.nodes,
      null,
      "features-core"
    )
  const proofCollection = resolveProofCollection(
    [page.proofCollection, ...data.allDatoCmsMcV2ProofCollection.nodes].filter(Boolean),
    null,
    "features-proof"
  )
  const testimonials = proofCollection.testimonials?.length
    ? proofCollection.testimonials
    : data.allDatoCmsMcV2TestimonialEntry.nodes
  const renderedFeatureAnchors = new Set(
    (featureCollection.featureSections || [])
      .map(section => section?.anchorId)
      .filter(Boolean)
  )
  const featureNavItems = (sectionCollection.contentSections || [])
    .filter(section => /^features_group_/.test(section?.sectionKey || ""))
    .filter(section => renderedFeatureAnchors.has(section.sectionKey.replace(/^features_group_/, "")))
    .map((section, index) => {
      const anchor = section.sectionKey.replace(/^features_group_/, "")
      const title = (section.eyebrow || section.editorLabel || anchor)
        .replace(/^\d+\s*·\s*/i, "")
        .trim()

      return {
        seedKey: `features_nav-${anchor}`,
        groupKey: "nav_item",
        rank: index + 1,
        title,
        href: `#${anchor}`,
      }
    })
  const contentSections = (sectionCollection.contentSections || []).map(section =>
    section?.sectionKey === "features_hero"
      ? {
          ...section,
          eyebrow: section.eyebrow || page.eyebrow || featureCollection.eyebrow,
          headingHtml: section.headingHtml || page.heading || featureCollection.titleHtml,
          summary: section.summary || page.summary || featureCollection.summary,
          contentItemEntries: [
            ...(section.contentItemEntries || []),
            ...featureNavItems,
          ],
        }
      : section
  )

  return (
    <CmsPage
      slug={page.slug}
      seo={page.seo}
      hideHero
      eyebrow={page.eyebrow}
      heading={page.heading}
      summary={page.summary}
      body={page.body}
      bodyHeading={page.bodyHeading || "Feature Catalog"}
      heroMediaType={page.heroMediaType}
      heroImageUrl={page.heroImageUrl}
      heroImageAlt={page.heroImageAlt}
      heroVideoUrl={page.heroVideoUrl}
      heroVideoPosterUrl={page.heroVideoPosterUrl}
      contentSections={contentSections}
      featureSections={featureCollection.featureSections || []}
      featureCards={featureCollection.featureCards || []}
      testimonials={testimonials}
      contentHtml=""
      fallbackContentHtml=""
      extraStyles={featuresExtraStyles}
      extraHeadLinks={prototypeSlice.extraHeadLinks}
      emptyMessage="Create or seed the features record in mc_v2_feature_catalog_page."
    />
  )
}

export default FeaturesPage

export const query = graphql`
  query FeaturesCmsPageQuery {
    allDatoCmsMcV2FeatureCatalogPage(filter: { slug: { eq: "features" } }, limit: 1) {
      nodes {
        seo {
          ...CmsSeoFields
        }
        slug
        eyebrow
        heading
        summary
        body
        # bodyHeading  # TODO(T-014 add the Dato field, T-015 then uncomment): blocked on DatoCMS schema
        heroMediaType
        heroImageUrl
        heroImageAlt
        heroVideoUrl
        heroVideoPosterUrl
        contentHtml
        sectionCollection {
          contentSections {
            ...CmsHtmlSectionFields
          }
        }
        featureCollection {
          eyebrow
          titleHtml
          summary
          featureSections {
            sectionKey
            anchorId
            displayMode
            eyebrow
            titleHtml
            summary
            itemsHeading
            previewHtml
            reverseLayout
          }
          featureCards {
            sectionKey
            icon
            title
            blurb
            previewHtml
            anchorLink
          }
        }
        proofCollection {
          sourceCollection {
            key
          }
          selectedTestimonialEntries {
            quote
            customerName
            customerInitials
            customerRole
            industry
            brandName
            metaOne
            metaTwo
            metaThree
            statOneValue
            statOneLabel
            statTwoValue
            statTwoLabel
            statThreeValue
            statThreeLabel
          }
          testimonialEntries {
            quote
            customerName
            customerInitials
            customerRole
            industry
            brandName
            metaOne
            metaTwo
            metaThree
            statOneValue
            statOneLabel
            statTwoValue
            statTwoLabel
            statThreeValue
            statThreeLabel
          }
        }
      }
    }
    allDatoCmsMcV2SectionCollection {
      nodes {
        key
        contentSections {
          ...CmsHtmlSectionFields
        }
      }
    }
    allDatoCmsMcV2FeatureCollection {
      nodes {
        key
        eyebrow
        titleHtml
        summary
        featureSections {
          sectionKey
          anchorId
          displayMode
          eyebrow
          titleHtml
          summary
          itemsHeading
          previewHtml
          reverseLayout
        }
        featureCards {
          sectionKey
          icon
          title
          blurb
          previewHtml
          anchorLink
        }
      }
    }
    allDatoCmsMcV2ProofCollection {
      nodes {
        key
        sourceCollection {
          key
        }
        selectedTestimonialEntries {
          quote
          customerName
          customerInitials
          customerRole
          industry
          brandName
          metaOne
          metaTwo
          metaThree
          statOneValue
          statOneLabel
          statTwoValue
          statTwoLabel
          statThreeValue
          statThreeLabel
        }
        testimonialEntries {
          quote
          customerName
          customerInitials
          customerRole
          industry
          brandName
          metaOne
          metaTwo
          metaThree
          statOneValue
          statOneLabel
          statTwoValue
          statTwoLabel
          statThreeValue
          statThreeLabel
        }
      }
    }
    allDatoCmsMcV2TestimonialEntry(
      filter: { customerName: { eq: "Meridian Arts Foundation" } }
      limit: 1
    ) {
      nodes {
        quote
        customerName
        customerInitials
        customerRole
        industry
        brandName
        metaOne
        metaTwo
        metaThree
        statOneValue
        statOneLabel
        statTwoValue
        statTwoLabel
        statThreeValue
        statThreeLabel
      }
    }
  }
`
